module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-right-text-d5c7ef2d.svg";